import { SadaKTabs } from './styles';
import { TabsProps } from 'antd';

type Props = TabsProps;

const KTabs = (props: Props) => <SadaKTabs size="large" {...props} />;

export default KTabs;
